import { render } from "./DashboardRiskCard.vue?vue&type=template&id=2cc49955"
import script from "./DashboardRiskCard.vue?vue&type=script&lang=js"
export * from "./DashboardRiskCard.vue?vue&type=script&lang=js"
script.render = render

export default script